import React, {useEffect, useState} from 'react'
import { Input} from "reactstrap";
import {usersByRole} from 'network/ApiAxios'

function SellerDropdown(props) {
    const [sellers, setSellers] = useState()
    const [shop, setShop] = useState();
    const [admin, setAdmin] = useState();
    const [sellermanager, setSellermanager] = useState();

    useEffect(() => {
        getSellers()
        getShop()
        getAdmin()
        getSellermanager()
      }, []);
    
      const getSellers = async()=>{
        const  response = await usersByRole("seller")
        setSellers(response.data)
      }

      const getShop = async()=>{
        const  response = await usersByRole("shop")
        setShop(response.data)
      }

      const getAdmin = async()=>{
        const  response = await usersByRole("admin")
        setAdmin(response.data)
      }

      const getSellermanager = async()=>{
        const  response = await usersByRole("sellermanager")
        setSellermanager(response.data)
      }


  return (
    <Input style={{width:props.width}} type="select" onChange={(e)=>props.handler(e.target.value)} >
        {sellers && <option key="choose" value='1' label='Choose a Seller' />
        }
        {sellers && sellers.map((seller)=>{
        return <option key={seller._id} value={seller._id} label={seller.name} >{seller.name}</option>
        })}
        {sellermanager && sellermanager.map((sellermanagerItem)=>{
        return <option key={sellermanagerItem._id} value={sellermanagerItem._id} label={sellermanagerItem.name} >{sellermanagerItem.name}</option>
        })}
        {shop && shop.map((shopItem)=>{
        return <option key={shopItem._id} value={shopItem._id} label={shopItem.name} >{shopItem.name}</option>
        })}
        {admin && admin.map((adminItem)=>{
        return <option key={adminItem._id} value={adminItem._id} label={adminItem.name} >{adminItem.name}</option>
        })}
        
    </Input>
  )
}

export default SellerDropdown